import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { processSessionId } from "../lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    processSessionId(sessionId)
      .then((user) => {
        // Clean up URL fragment and go to dashboard
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user } });
      })
      .catch(() => {
        navigate("/");
      });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-16 h-16 mx-auto rounded-full border-2 border-[#D4AF37]/40 border-t-[#D4AF37] animate-spin-slow" />
        <p className="mt-6 text-[#334155] font-display text-2xl">Aligning your stars…</p>
      </div>
    </div>
  );
}
